module.exports = __webpack_public_path__ + "static/media/stripe-logo-slate.875a4de7.svg";